import { render, staticRenderFns } from "./ContentWithSidebarLayout.vue?vue&type=template&id=32523992&scoped=true&"
import script from "./ContentWithSidebarLayout.vue?vue&type=script&lang=js&"
export * from "./ContentWithSidebarLayout.vue?vue&type=script&lang=js&"
import style0 from "./ContentWithSidebarLayout.vue?vue&type=style&index=0&id=32523992&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32523992",
  null
  
)

export default component.exports